import React from "react";
//#region types
import { CompanyEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { OwnersWidgetContainerProps } from "models/propTypes/holdingRegisterPropTypes";
//#endregion
//#region components
import { ViewPanel } from "components/common";
import OwnersWidget from "./ownersWidget";
import OwnersViewTypeToggle from "./ownersViewTypeToggle";
import { useShareRegisterService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const OwnersWidgetContainer: React.FC<OwnersWidgetContainerProps> = ({ snapshotDate }) => {
  const shareRegisterService = useShareRegisterService();

  const [ownerInfoAvailable, setHasOwnerInfoAvailable] = React.useState<boolean>();

  const [ownersViewType, setOwnersViewType] = React.useState<CompanyEnums.OwnersViewType>(
    CompanyEnums.OwnersViewType.Shareholder
  );

  const loadShareRegisterEvents = () => {
    shareRegisterService
      .getHasOwnerInformationAvailable(snapshotDate)
      .then((result) => {
        setHasOwnerInfoAvailable(result);
      })
      .catch(() => {
        setHasOwnerInfoAvailable(false);
      });
  };

  React.useEffect(() => {
    loadShareRegisterEvents();
  }, []);

  const onOwnersViewTypeChanged = (type: CompanyEnums.OwnersViewType) => {
    if (ownersViewType !== type) setOwnersViewType(type);
  };

  return ownerInfoAvailable ? (
    <ViewPanel
      icon={IconDefinitionConstants.WDocument}
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Reports.OwnerInformation)}
      description={
        snapshotDate
          ? undefined
          : LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Company.LatestKnownOwnerPicture)
      }
      appearance="lg"
      gridSize="lg"
      topRightContent={<OwnersViewTypeToggle onSwitchTypeChanged={onOwnersViewTypeChanged} />}
    >
      <OwnersWidget switchType={ownersViewType} shapshotDate={snapshotDate} />
    </ViewPanel>
  ) : (
    <></>
  );
};

export default OwnersWidgetContainer;
